import {PriceModel} from '../Price.model';
import {ModelContext} from '../../../types/app.types';
import {currentCartV2} from '@wix/ecom';
import {MembershipModel} from './Membership.model';

export class PaymentConfigModel {
  public savePaymentMethod: boolean;
  public depositAmount: PriceModel;
  public paymentOption: PaymentOption;
  public membership?: MembershipModel;

  constructor(params: PaymentConfigModel) {
    this.savePaymentMethod = params.savePaymentMethod;
    this.depositAmount = params.depositAmount;
    this.paymentOption = params.paymentOption;
    this.membership = params.membership;
  }

  public static fromCartV2(
    paymentConfig: currentCartV2.ItemPaymentConfig,
    modelContext: ModelContext
  ): PaymentConfigModel {
    return new PaymentConfigModel({
      savePaymentMethod: paymentConfig.savePaymentMethod,
      depositAmount: paymentConfig.depositAmount
        ? PriceModel.fromCartV2(paymentConfig.depositAmount, modelContext)
        : undefined,
      paymentOption: paymentOptionMap[paymentConfig.paymentOption],
      membership: MembershipModel.fromCartV2(paymentConfig.membership),
    });
  }
}

export enum PaymentOption {
  DEPOSIT_ONLINE = 'DEPOSIT_ONLINE',
  FULL_PAYMENT_OFFLINE = 'FULL_PAYMENT_OFFLINE',
  FULL_PAYMENT_ONLINE = 'FULL_PAYMENT_ONLINE',
  MEMBERSHIP = 'MEMBERSHIP',
  MEMBERSHIP_OFFLINE = 'MEMBERSHIP_OFFLINE',
  MEMBERSHIP_ONLINE_WITH_OFFLINE_REMAINDER = 'MEMBERSHIP_ONLINE_WITH_OFFLINE_REMAINDER',
}

const paymentOptionMap: Record<currentCartV2.PaymentOptionType, PaymentOption> = {
  [currentCartV2.PaymentOptionType.DEPOSIT_ONLINE]: PaymentOption.DEPOSIT_ONLINE,
  [currentCartV2.PaymentOptionType.MEMBERSHIP]: PaymentOption.MEMBERSHIP,
  [currentCartV2.PaymentOptionType.MEMBERSHIP_ONLINE_WITH_OFFLINE_REMAINDER]:
    PaymentOption.MEMBERSHIP_ONLINE_WITH_OFFLINE_REMAINDER,
  [currentCartV2.PaymentOptionType.MEMBERSHIP_OFFLINE]: PaymentOption.MEMBERSHIP_OFFLINE,
  [currentCartV2.PaymentOptionType.FULL_PAYMENT_OFFLINE]: PaymentOption.FULL_PAYMENT_OFFLINE,
  [currentCartV2.PaymentOptionType.FULL_PAYMENT_ONLINE]: PaymentOption.FULL_PAYMENT_ONLINE,
};
